import module from '../module';

function OrderTabPayModeController($scope, groupOrderService) {

    $scope.configuration = {
        groupPay: groupOrderService.getGroupPay()
    };

    $scope.selectGroupPay = function (mode) {

        groupOrderService.setGroupPay(mode);
        groupOrderService.setSinglePayOrder(groupOrderService.getSinglePayOrder() || {});

        if (!mode) {
            $scope.cancelPreview();
        }

        $scope.next();
    };

}

module.controller('OrderTabPayMode', ['$scope', 'GroupOrder', OrderTabPayModeController]);


// WEBPACK FOOTER //
// ./src/modules/order/controllers/OrderTabPayModeController.js